import React, { useState } from 'react';
import './FlashSaleAlert.scss';
import { SessionKeys } from '../../utils/AppUtils';
import { Modal } from 'react-bootstrap';
import FlashTermAndCondModal from './FlashTermAndCondModal';
 
const FlashSaleAlert = () => {
  const [show, setShow] = useState(true);
  const [showModal, setShowModal] = useState(false);
 
  if (!show) return null;
 
  return (
    <>
<div className="alert alert-warning flash-sale-alert alert-dismissible fade show" role="alert">
<div className="d-flex justify-content-between align-items-center">
<div className='flash_sale'>
<span className="alert-heading">🎉 FLASH SALE!</span>
<p className="alert-body mb-0">
<strong>10% OFF! (ALL PAID COURSES)</strong><br />
            DEC 11,12:00 AM - DEC 12, 11:59 PM
</p>
<u><strong className='cursor-pointer' onClick={()=>{setShowModal(true)}}><u>Terms & Conditions apply</u></strong></u>
</div>
<button type="button" className="btn-close" onClick={() =>{
    localStorage.setItem(SessionKeys.FLASH,"true");
     setShow(false)}} aria-label="Close"></button>
</div>
</div>
<FlashTermAndCondModal
showModal = {showModal}
setShowModal = {setShowModal}
/>
</>
  );
};
 
export default FlashSaleAlert;